// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","quadrado":"Footer_quadrado__nqzf0","quadredoUm":"Footer_quadredoUm__YWfLO","quadredoDois":"Footer_quadredoDois__AYXzq"};